import { useParams } from 'react-router-dom';

import TiersOverview from '../../features/tiers/layouts/overview';
import TierDetail from '../../features/tiers/layouts/detail';
import CreateTierForm from '../../features/tiers/forms/create';
import EditTierForm from '../../features/tiers/forms/edit';
import BreakdownScreen from '../../features/breakdown/layouts/breakdown';

// TSS vite/01 §"Pages are thin" — read the URL, mount a feature.
//
// Four routes, three permissions: reading is `tiers:read`, editing is
// `tiers:write`, and the breakdown is `breakdown:read` — a code of its own that
// `technician` and `agent_master` hold, and which is what the agreement screen
// actually reads.

export default function TiersPage({ mode }) {
    const { id } = useParams();

    if (mode === 'create' || id === 'new') return <CreateTierForm />;
    if (mode === 'edit' && id) return <EditTierForm tierId={id} />;
    if (mode === 'breakdown' && id) return <BreakdownScreen tierId={id} />;
    if (id) return <TierDetail tierId={id} />;
    return <TiersOverview />;
}
